import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import ClearShieldDemo from "@/components/site/ClearShieldDemo";
import HowItWorks from "@/components/site/HowItWorks";
import Booking from "@/components/site/Booking";
import Aftercare from "@/components/site/Aftercare";
import Terms from "@/components/site/Terms";
import FAQs from "@/components/site/FAQs";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

const Home = () => (
  <div className="overflow-x-hidden">
    <Navbar />
    <Hero />
    <About />
    <Services />
    <ClearShieldDemo />
    <HowItWorks />
    <Booking />
    <Aftercare />
    <Terms />
    <FAQs />
    <Contact />
    <Footer />
    <WhatsAppButton />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
